import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import {
  BILLING_TYPE,
  CREDIT_TIME,
  DEFAULT_PAGE_SIZE,
  FOOD_PUBLIC_TYPE,
  SUPPLIER_TYPE,
} from '../../../../../config/constants';
import supplierPropTypes from '../proptypes/SupplierProptypes';
import Table from '../../../../common/Table';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import EnumStatus from '../../../../common/EnumStatus';

const SupplierBasicInformationResource = ({
  business,
  location,
  billingType,
  type,
  creditTime,
  bankAccountNumber,
  active,
  user,
  supplierFoodTypeList,
  phoneNumber,
}) => (
  <>
    <ResourceProperty label="RUC:">
      {business.businessTaxId || '-'}
    </ResourceProperty>

    <ResourceProperty label="Razon Social:">
      {business.name || '-'}
    </ResourceProperty>

    <ResourceProperty label="Ubicación:">
      {location ? location.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Tipo de comprobante:">
      {BILLING_TYPE[billingType].label || billingType || '-'}
    </ResourceProperty>

    <ResourceProperty label="Tipo de proveedor:">
      {SUPPLIER_TYPE[type].label || type || '-'}
    </ResourceProperty>

    <ResourceProperty label="Tiempo de crédito:">
      {CREDIT_TIME[creditTime].label || creditTime || '-'}
    </ResourceProperty>

    <ResourceProperty label="N° de cuenta bancaria:">
      {bankAccountNumber || '-'}
    </ResourceProperty>

    <ResourceProperty label="Número de teléfono:">
      {phoneNumber || '-'}
    </ResourceProperty>

    <h5>Usuario Asociado</h5>

    <ResourceProperty label="Nombre:">
      {user ? user.fullName : '-'}
    </ResourceProperty>

    <ResourceProperty label="Email:">
      {user ? user.username : '-'}
    </ResourceProperty>

    <ResourceProperty label="Activo:">{active ? 'Sí' : 'No'}</ResourceProperty>

    <h3>Tipo de Alimentación</h3>
    <Table
      columns={[
        {
          Header: 'Alimentación',
          accessor: 'food.name',
          className: 'text-center',
        },
        {
          Header: 'Costo Unitario',
          accessor: 'cost',
          className: 'text-center',
        },
        {
          Header: 'Tipo de público',
          accessor: 'publicType',
          className: 'text-center',
          Cell: (row) => (
            <EnumStatus enumObject={FOOD_PUBLIC_TYPE} enumValue={row.value} />
          ),
        },
      ]}
      data={supplierFoodTypeList}
      manual={false}
      defaultFilterMethod={filterMethodCaseInsensitive}
      defaultPageSize={
        supplierFoodTypeList.length > 10
          ? DEFAULT_PAGE_SIZE
          : supplierFoodTypeList.length
      }
      showPagination={supplierFoodTypeList.length > 10}
    />
  </>
);

SupplierBasicInformationResource.propTypes = supplierPropTypes;

export default SupplierBasicInformationResource;
